import React from 'react';
export function Footer() {
  return <footer className="bg-card-bg border-t border-[rgba(107,0,182,0.3)] py-[30px] px-5 text-center" data-id="element-47">
      <p className="text-[0.8rem] text-white/35 leading-[1.8]" data-id="element-48">
        © 2025 Dr. Eduardo Ortiz — PLACER, CULPA Y VACÍO · El Camino a la
        Recuperación
        <br data-id="element-49" />
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-50">
          Términos y condiciones
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-51">
          Política de privacidad
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/40 no-underline hover:text-magenta-bright transition-colors" data-id="element-52">
          Contacto
        </a>
      </p>
    </footer>;
}